/**
 * Changes the body attribute
 */

import moment from "moment";
import momentTZ from "moment-timezone";

 const changeHTMLAttribute = (attribute, value) => {
    if (document.documentElement) document.documentElement.setAttribute(attribute, value);
    return true;
}
export { changeHTMLAttribute };




export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert file to base64
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };


  export const base64ToFile = (base64String, fileName) => {
    if(!base64String){
      return null
    }
    const mimeType = base64String.match(/data:([^;]+);base64/)[1]; // Extract MIME type
    const byteString = atob(base64String.split(',')[1]); // Decode base64
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeType });
  
    // Convert Blob to File
    return new File([blob], fileName+`.${mimeType.split('/')[1]}`, { type: mimeType });
  };



  
  export function convertGmtToUserLocal(gmtTimeString) {
    // console.log(gmtTimeString)
    // Parse the GMT time
    const gmtTime = moment.utc(gmtTimeString, 'ddd, DD MMM YYYY HH:mm:ss [GMT]');

    // Get the user's local time zone
    const userTimeZone = momentTZ.tz.guess();
    
    // Convert GMT time to the user's local time zone
    const localTime = gmtTime.tz(userTimeZone);

    // Return the local time and user's time zone
    return  localTime.format('dddd, MMMM D, YYYY h:mm:ss A ') // Example format
    
}


export function convertISODateToUserLocal(gmtTimeString) {

  // Parse the GMT time
  const gmtTime = moment.utc(gmtTimeString);

  // Get the user's local time zone
  const userTimeZone = momentTZ.tz.guess();
  
  // Convert GMT time to the user's local time zone
  const localTime = gmtTime.tz(userTimeZone);

  // Return the local time and user's time zone
  return  localTime.format('dddd, MMMM D, YYYY h:mm A ') // Example format
  
}



export function convertUTCToLocal(utcTimeString) {
  // Parse the UTC time using moment
  const utcTime = moment.utc(utcTimeString);

  // Get the user's local time zone
  const userTimeZone = momentTZ.tz.guess();

  // Convert the UTC time to the user's local time zone
  const localTime = utcTime.tz(userTimeZone);

  // Format the local time
  return localTime.format('dddd, MMMM D, YYYY h:mm:ss A');
}


export function convertUTCToLocal_OnlyDate(utcTimeString) {
  // Parse the UTC time using moment
  const utcTime = moment.utc(utcTimeString);

  // Get the user's local time zone
  const userTimeZone = momentTZ.tz.guess();

  // Convert the UTC time to the user's local time zone
  const localTime = utcTime.tz(userTimeZone);

  // Format the local time
  return localTime.format('dddd, MMMM D, YYYY');
}



export function convertDate(dateString) {
  // Parse the date string using moment
  const date = moment(new Date(dateString));
  
  // Format the date to 'dd-mm-yyyy'
  return date.format('YYYY-MM-DD');
}

export function reviveFunctions(obj) {
  for (let key in obj) {
    if (typeof obj[key] === "string" && obj[key].startsWith("function")) {
      // convert "function(val) { ... }" → actual function
      obj[key] = eval("(" + obj[key] + ")");
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      reviveFunctions(obj[key]);
    }
  }
  return obj;
}


export function groupByPromptCategory(data) {
  const grouped = {};

  data?.Prompt_wih_sql?.forEach(item => {
    const category = item.PromptCategory.trim(); // normalize by trimming spaces

    if (!grouped[category]) {
      grouped[category] = [];
    }

    grouped[category].push(item);
  });

  return grouped;
}